<ng-container *transloco="let t">
  <app-page-template [displayLargeMobileFooter]="false">
    <div class="container">
      <div class="pt-120-60 pb-300-100">
        <app-grey-card-with-title [title]="t('app.common.login')" [removeContentPaddingTop]="true">
          <div class="pb-20 pt-20">
            <p class="regular d-inline">{{t('signup.already.have.an.account')}}</p>
            <p class="regular cursor-pointer ps-2 underline-link d-inline" (click)="toLogin()">{{
                t('app.common.login')
              }}</p>
          </div>
          <div class="pt-16">
            <form #authFormEdit="ngForm" [formGroup]="inputForm">
              <app-input formControlName="email" label="app.common.user.email"/>
              <div class="pt-20-10">
                <app-input type="password" formControlName="password" label="app.common.password"/>
              </div>

              <div class="pt-30-28 d-flex justify-content-between">
                <div class="d-flex align-items-center">
                  <input class="form-check-input" type="checkbox" formControlName="rememberMe"/>
                  <p class="small ps-2">Remember me</p>
                </div>
                <div class="d-flex">
                  <p class="small ps-2" (click)="goToRecoverPasswordPage()">
                  <span class="text-decoration-underline cursor-pointer">{{
                      t("app.common.forgot.password")
                    }}</span>. </p>
                </div>
              </div>

              <div class="pt-20-10 mt-30">
                <app-button-alt [text]="t('app.common.login.button')"
                                (onClickCallback)="onSubmit()" [isFullWidth]="true"
                                [isDisabled]="!authFormEdit.valid"></app-button-alt>
              </div>
              <app-section-divider/>
              <div class="row">
                <div class="col-12">
                  <app-google-signin-button/>
                </div>
              </div>
            </form>
          </div>
        </app-grey-card-with-title>
      </div>
    </div>
  </app-page-template>
</ng-container>
